import React from 'react';
import BaseEventTaskForm from './BaseEventTaskForm';
import UpdateTaskButtons from '../UpdateTaskButtons';
import { AfterSubmitFunc } from 'ui-builder';
import { PlanTask, usePlanTasksService } from 'nekst-api';

export interface UpdateEventTaskFormProps {
  afterSubmitFunc?: AfterSubmitFunc,
  data: PlanTask
}

export default function UpdateEventTaskForm(props: UpdateEventTaskFormProps) {
  const planTasksService = usePlanTasksService();
  return (
    <BaseEventTaskForm
      title={props.data.name}
      planId={props.data.planId}
      initialData={props.data}
      submitFormFunc={(data) => planTasksService.updateTask(data.id, data)}
      afterSubmitFunc={props.afterSubmitFunc}
      validationSchema={planTasksService.getEventTaskValidationSchema()}
      buttons={<UpdateTaskButtons />}
    />
  );
}
